import canUse from './canUse'

const SetToken = (token) => canUse() && localStorage.setItem('TOKEN', token)

export default SetToken
